'use client';

import { ShareButton as BioShareButton } from '@ps/features/sharing/ShareButton';
import type { BioContext } from '@ps/functions/bio/bioContext';
import { Share } from 'lucide-react';

/**
 * Circular share chip beside the product name (mirrors RN
 * `ListingDetailShareIcon`). A thin skin over the shared
 * {@link BioShareButton} — it owns the chip styling + icon; the shared button
 * builds the canonical, custom-domain-aware product permalink and opens the
 * app-wide `ShareModal`.
 */
export function ShareButton({
  listingId,
  bioContext,
  slug,
  title,
}: {
  listingId: string;
  /** Bio context — with `slug`, shares the creator-scoped slug URL, else the
   *  legacy `/products/{creatorId}/{listingId}`. */
  bioContext: BioContext;
  slug?: string;
  title: string;
}) {
  return (
    <BioShareButton
      bioContext={bioContext}
      target={{ kind: 'product', id: listingId, slug }}
      title={title}
      className="relative inline-flex size-8 shrink-0 items-center justify-center rounded-full border border-black text-black transition hover:bg-zinc-50"
    >
      <Share className="size-4" aria-hidden />
    </BioShareButton>
  );
}
